"use client"

import clsx from "clsx"

import { Link, type LinkProps } from "~/components/ui/Link"

import { text } from "~/styles/variants"

import * as css from "./styles.css"

function NavigationCta({ className, children, ...rest }: LinkProps) {
  return (
    <Link className={clsx(className, text, css.navigationCta)} activeClassName={css.active} {...rest}>
      <div className={css.children}>
        <>{children}</>
      </div>
    </Link>
  )
}

export default NavigationCta
